import { Matcher } from 'react-day-picker';

const useDisabledMatchers = (minDate: Date | undefined, maxDate: Date | undefined) => {
  const disabled = [minDate && { before: minDate }, maxDate && { after: maxDate }].filter(Boolean) as Matcher[];

  return disabled.length > 0 ? disabled : undefined;
};

export default useDisabledMatchers;
